// extracted by mini-css-extract-plugin
export default {"shake":"GameGrid_shake__F4KuA","shake-horizontal":"GameGrid_shake-horizontal__rK1kz"};